module.exports = __webpack_public_path__ + "media/start_bet.d893d6c0.mp3";